app.factory('pictureService', ['$http', '$uibModal', 'cfpLoadingBar', 'paperworkService',
    function ($http, $uibModal, cfpLoadingBar, paperworkService) {

        var POs;

        return {
            findEvents: function () {
                return $http.get('/api/pictures/calendar')
                    .then(res => res.data, errorHandler)
                    .then(events => _.map(events, ev => {
                        ev.startsAt = moment(ev.startsAt).toDate();
                        return ev;
                    }))
            },

            openEvent: function (event) {
                let modalInstance = $uibModal.open({
                    controller: 'PictureModalController',
                    templateUrl: 'src/picture/html/picture-calendar-modal.html',
                    keyboard: true,
                    animation: false,
                    resolve: {
                        calendarEvent: function () {
                            return event;
                        }
                    }
                });
                return modalInstance;
            },

            findPOs: function (event) {
                let filter = {
                    "data_saida": event.startsAt,
                    "id_empresa": event.id_empresa
                };

                return $http.post('/api/pictures/departure', filter)
                    .then(res => res.data, errorHandler)
                    .then(pos => _.map(pos, po => { po.isDownloaded ? po.situation = "Downloaded" : ""; return po }))
                    .then(result => { POs = result; return result });
            },

            findPoList: function () {

                alert.info("<i class='fa fa-refresh fa-spin fa-fw'></i> Searching pictures...", "Info", { "timeOut": 0, "extendedTimeOut": 0 });

                // return $http.get('/api/pictures/list')
                return $http.get('/api/v2/pictures/list')
                    .then(res => res.data, errorHandler)
                    .then(pos => _.orderBy(pos, 'isDownloaded', 'asc'))
                    .then(pos => {
                        alert.clearAll();
                        return pos;
                    })
                // .then(pos => _.map(pos, po => { po.isDownloaded ? po.situation = "Downloaded" : ""; return po }))
            },

            downloadBulk: function (pos){
                if(!confirm("Are you sure? This will set all POs as 'Downloaded' and clear the list")) return

                const nonDownloaded = _.filter(pos, po => po.isDownloaded === false)
                const poNumbers = _.map(nonDownloaded, 'poNumber')

                console.log(poNumbers)

                $http.post('/api/pictures/download-bulk', poNumbers)
                .catch(errorHandler)
                .then(res => res.data)
                .then(() => {
                    alert.info('Resquet sent. <br>We will process the pictures and send you an email in a few minutes')
                })
            },


            downloadPictures: function (pos, date) {
                let zip = new JSZip();
                let urls = []
                let errors = [];
                let folder = {};
                let folderName = "";
                let alertMessage = {};

                pos = _.castArray(pos);

                if (pos.length == 1) folderName = pos[0].poNumber;
                if (pos.length > 1 && date) folderName = moment(date).format('YYYY-MM-DD');

                // folder = zip.folder(folderName);

                urls = _.map(pos, po => po.poUrl);
                pos = _.map(pos, po => po.poNumber);

                return $http.post('/api/v2/pictures/download', { "pos": pos })
                    .then(res => res.data, errorHandler)
                    // .then(r => { console.log(r); return r})
                    // .then(files => { alertMessage = showDownloadingAlert(files.length); return files; })
                    // .then(r => { console.log(r); return r})
                    // .then(files => _.map(files, file => getBinary(file, $http, errors)))
                    // .then(Promise.all)
                    .then(r => { console.log(r); return r })
                    // .then(result => { handlePictureError(errors); return result})
                    .then(files => _.map(files, file => addToZip(file, zip)))
                    .then(files => createZipFile(zip, folderName))
                    .then(() => $http.post('/api/pictures/downloaded', { "pos": pos }))
                    // .then(newPos => { toastr.clear(alertMessage); return newPos; })
            },

            downloadNonDownloaded: function (poList) {
                let nonDownloaded = _.filter(poList, po => po.isDownloaded === false);

                // baixa só os 40 primeiros pois estava dando problema de timeout
                nonDownloaded = _.slice(nonDownloaded, 0, 25)

                return this.downloadPictures(nonDownloaded, undefined);
            }

        };
    }]);

function addToZip(file, folder) {
    folder.file(file.file_name, file.bin, { "base64": true })
    return file;
}

function createZipFile(zipProvider, zipName) {
    zipProvider.generateAsync({ type: "blob" })
        .then(function (content) {
            saveAs(content, _.toString(zipName) + ".zip");
        });
}

function getBinary(file, http, errors) {
    let File = (name, bin) => { return { bin: bin, file_name: name } };
    let config = { responseType: "arraybuffer", ignoreLoadingBar: true, ignoreAuth: true };

    return http.get(file.url, config)
        .catch(error => {
            console.log('Error:' + error)
            errors.push(file.file_name);
            return undefined;
        })
        .then(res => {
            if (res) return res.data
            return undefined;
        })
        .then(bin => {
            if (bin) return File(file.file_name, bin)
            return undefined;
        })
}

function handlePictureError(errors) {
    if (errors.length > 0) {
        toastr.clear();
        let message = "<p> The pictures below are not available: </p>";
        _.forEach(errors, e => message += "<p style='font-size:13px'><i>" + e + "</p>");
        alert.error(message, "Error", { "timeOut": 0, "extendedTimeOut": 0 })

        throw new Error("Error downloading pictures");
    }
}

function showDownloadingAlert(imageQty) {
    let config = { "timeOut": 0, "extendedTimeOut": 0 };
    if (imageQty > 7) {
        let message = "Downloading " + imageQty + " pictures <i class='fa fa-refresh fa-spin fa-fw'></i>";
        return toastr.info(message, "Info", config);
    }
    return toastr.info("Downloading pictures <i class='fa fa-refresh fa-spin fa-fw'></i>", "Info", config);
}